import React, { FC, useState } from 'react'
import { ConnectedProps, connect } from 'react-redux'

import getSyncedEnergyMotionRecordSource from '../utils/getSyncedEnergyMotionRecordSource'

import CopyJournalRecordModal from './Modals/CopyJournalRecordModal'
import AddEnergyMotionRecord from './Modals/JournalAddModal/components/AddOrEditEnergyMotionRecord'
import MoveJournalRecordModal from './Modals/MoveJournalRecordModal'

import { CardIconButton, JournalCardEnergyMotion } from 'Components'
import {
  activateButton,
  copyButton,
  deactivateButton,
  deleteButton,
  editButton,
  moveButton
} from 'Components/IconButton/iconButtons'
import { JournalEnergyMotionRecord } from 'Models'
import { useAppDispatch } from 'ReduxStore/hooks'
import {
  addJournalEnergyMotionRecordAction,
  removeJournalEnergyMotionRecordAction,
  updateJournalEnergyMotionRecordAction
} from 'ReduxStore/journalEnergyMotionRecords'
const mapDispatchToProps = {
  removeJournalEnergyMotionRecord: removeJournalEnergyMotionRecordAction,
  addJournalEnergyMotionRecord: addJournalEnergyMotionRecordAction
}

const connector = connect(null, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
  journalEnergyMotionRecord: JournalEnergyMotionRecord
}

const JournalCardEnergyContainer: FC<Props> = ({
  journalEnergyMotionRecord,
  removeJournalEnergyMotionRecord,
  addJournalEnergyMotionRecord
}: Props) => {
  const dispatch = useAppDispatch()
  const { id, energy, description, duration, source, hidden } = journalEnergyMotionRecord

  const [isOpen, setOpen] = useState(false)
  const [copyModalIsOpen, setCopyModalIsOpen] = useState(false)
  const [displayedDuration, setDisplayedDuration] = useState<number | undefined>(duration)
  const isSyncedRecord = getSyncedEnergyMotionRecordSource(source) !== 'none'

  const [moveModalIsOpen, setMoveModalIsOpen] = useState(false)

  const onCopy = (date: Date): void => {
    if (displayedDuration) {
      addJournalEnergyMotionRecord(description, energy, displayedDuration, date)
    }
  }

  const onReset = (): void => {
    setCopyModalIsOpen(false)
    setMoveModalIsOpen(false)
    setDisplayedDuration(duration)
  }

  const onMove = (date: Date): void => {
    dispatch(
      updateJournalEnergyMotionRecordAction({
        id: journalEnergyMotionRecord.id,
        energy,
        description,
        duration: duration,
        datetime: date
      })
    )

    setMoveModalIsOpen(false)
  }

  const callbackActivateDeactivateButton = (): void => {
    dispatch(
      updateJournalEnergyMotionRecordAction({
        id: journalEnergyMotionRecord.id,
        hidden: !hidden,
        energy,
        description,
        duration
      })
    )
  }
  const callbackCopyButton = (): void => setCopyModalIsOpen(!copyModalIsOpen)
  const callbackMoveButton = (): void => setMoveModalIsOpen(!moveModalIsOpen)
  const callbackDeleteButton = (): void => removeJournalEnergyMotionRecord(id)
  const callbackEditButton = (): void => setOpen(true)

  const renderIconButtons = (): CardIconButton[] => {
    if (isSyncedRecord) {
      if (hidden) {
        return [activateButton(callbackActivateDeactivateButton)]
      }

      return [deactivateButton(callbackActivateDeactivateButton)]
    }

    return [
      editButton(callbackEditButton),
      copyButton(callbackCopyButton),
      moveButton(callbackMoveButton),
      deleteButton(callbackDeleteButton)
    ]
  }

  return (
    <>
      <AddEnergyMotionRecord
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        journalEnergyMotionRecord={journalEnergyMotionRecord}
      />
      <CopyJournalRecordModal isOpen={copyModalIsOpen} onReset={onReset} title={description} onCopy={onCopy} />
      <MoveJournalRecordModal isOpen={moveModalIsOpen} title={description} onReset={onReset} onMove={onMove} />
      <JournalCardEnergyMotion
        energyMotionRecord={{ energy, description, duration, source, hidden }}
        cardButtons={[]}
        iconButtons={renderIconButtons()}
      />
    </>
  )
}

export default connector(JournalCardEnergyContainer)
